// @ts-nocheck
import { DateUtils } from '@fulcrumapp/fulcrum-core';
import { FeatureGetter } from './types';

export const CHANGE_TYPE_LOCATION_KEY = '@location';
export const CHANGE_TYPE_KEY = 'key';

export enum ChangeTypeByKey {
  '@status' = 'change-status',
  '@assignment' = 'change-assignment',
  '@repeat' = 'change-repeat',
  '@project' = 'change-project',
  '@location' = 'change-location',
  'schedule_date' = 'change-schedule',
  'key' = 'change',
}

export const EmptyQueue = {
  callback: () => undefined,
  evt: {
    key: '',
    name: '',
    field: '',
    value: '',
  },
};

export const getFeatureVariables = ({ ...params }: FeatureGetter) => {
  const { app, record, feature } = params;
  const { parseDate, formatEpochTimestamp } = DateUtils;
  return {
    userEmail: app.user.email,
    userFullName: app.user.fullName,
    userRoleName: app.role.name,
    recordID: record.id,
    recordStatus: record.status,
    recordClientCreatedAt: record.client_created_at
      ? formatEpochTimestamp(parseDate(record.client_created_at))
      : '',
    recordClientUpdatedAt: record.client_updated_at
      ? formatEpochTimestamp(parseDate(record.client_updated_at))
      : '',
    recordProject: record.project_id,
    recordProjectName: '',
    recordGeometry: record.geometryAsGeoJSON,
    recordAltitude: record.altitude,
    recordVerticalAccuracy: record.vertical_accuracy,
    recordHorizontalAccuracy: record.horizontal_accuracy,
    recordCreatedLatitude: record.created_latitude,
    recordCreatedLongitude: record.created_longitude,
    recordCreatedAltitude: record.created_altitude,
    recordCreatedAccuracy: record.created_accuracy,
    recordUpdatedLatitude: record.updated_latitude,
    recordUpdatedLongitude: record.updated_longitude,
    recordUpdatedAltitude: record.updated_altitude,
    recordUpdatedAccuracy: record.updated_accuracy,
    recordCreatedDuration: record.created_duration,
    recordUpdatedDuration: record.updated_duration,
    recordEditedDuration: record.edited_duration,
    featureID: feature?.id,
    featureIsNew: !!record.id,
    featureCreatedAt: formatEpochTimestamp(feature?.created_at),
    featureUpdatedAt: formatEpochTimestamp(feature?.updated_at),

    featureGeometry: feature?.geometryAsGeoJSON,
    featureCreatedLatitude: feature?.created_latitude,
    featureCreatedLongitude: feature?.created_longitude,
    featureCreatedAltitude: feature?.created_altitude,
    featureCreatedAccuracy: feature?.created_accuracy,
    featureUpdatedLatitude: feature?.updated_latitude,
    featureUpdatedLongitude: feature?.updated_longitude,
    featureUpdatedAltitude: feature?.updated_altitude,
    featureUpdatedAccuracy: feature?.updated_accuracy,
    featureCreatedDuration: feature?.created_duration,
    featureUpdatedDuration: feature?.updated_duration,
    featureEditedDuration: feature?.edited_duration,
    currentLocation: null,
  };
};
